<fgb-page-header [pageTitle]="'wallet.redeemed.title'" [showBalance]="false" [backButtonLink]="'/rewards/wallet'" />
<div class="container">
  <div class="d-none d-lg-block align-items-center mt-3 pb-2">
    <!-- Back Button -->
    <div class="reward-back-btn-bg cursor-pointer d-flex align-items-center justify-content-center" [routerLink]="'/rewards/wallet'">
      <span class="material-icons icons ms-2 text-white"> arrow_back_ios </span>
    </div>
    <!-- Title -->
    <h5 class="m-0 mt-3 text-grey wallet-redeemed-title text-capitalize">{{ 'wallet.redeemed.title' | translate }}</h5>
    <div class="back-button"></div>
  </div>

  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [style]="'list'"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="container">
    <div class="border">
      <div class="fw-bold font-size-12 text-center text-grey py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
